import { insertOrUpdateBlock } from "@blocknote/core";
import type { BnEditor } from "blocks-schema";
import { Colors, type PersistedTheme } from "schemas";
import { Icon, iconStyles } from "ui";

export function insertSocialLinksBlockItems(editor: BnEditor, theme: PersistedTheme) {
  return [
    {
      title: "Social Links",
      onItemClick: () =>
        insertOrUpdateBlock(editor, {
          type: "socialLinksBlock",
          props: {
            links: "",
            buttonBackgroundColor: theme.buttonHexColor || Colors.Primary,
            buttonTextColor: theme.buttonTextColor || Colors.Neutral0,
          },
        }),
      aliases: ["social", "links", "social media", "socials"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="SocialInstagram" />,
      subtext: "Add social media links buttons",
    },
  ];
}
